'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	OWNER_ROLE = 'owner';
module.exports = function SubteamModel(subteamApi, authenticationModel, s3Api, subscriptionModel) {
	if (!subteamApi || !authenticationModel || !s3Api || !subscriptionModel) {
		throw new Error('invalid-args');
	}
	const self = observable(this),
		currentContext =  {
			isStarted: false,
			isActive: false,
			teamList: []
		},
		buildContext = progressMessage => {
			const context =  Object.assign({}, currentContext);
			context.hasTeams = !!(currentContext.teamList.length);
			if (progressMessage) {
				context.progressMessage = progressMessage;
			}
			return context;
		},
		sendContext = progressMessage => {
			const context = buildContext(progressMessage);
			self.dispatchEvent('context', context);
			return context;
		},
		mapMemberList = memberList => {
			return authenticationModel.getLicense()
			.then(license => {
				const userId = license && ((license.subAccount && `${license.account}/${license.subAccount}`) || license.account);
				return memberList.map(member => {
					if (member.account === userId) {
						return Object.assign({isMe: true}, member);
					}
					return member;
				});
			})
			.then((memberList) => {
				return memberList;
			});

		},
		loadTeamList = async () => {
			sendContext('Loading group list, please wait...');
			const teamList = await subteamApi.listTeams();
			currentContext.teamList = teamList || [];
			return sendContext();
		},
		refreshSubTeam = (currentSubteam) => {
			return currentContext.teamList.find(subteam => subteam.teamId === currentSubteam.teamId);
		};

	authenticationModel.addEventListener('not-authenticated', () => {
		if (currentContext.isStarted) {
			currentContext.isActive = false;
			return sendContext();
		}
	});
	self.start = (goldAccountInfo)  => {
		const license = goldAccountInfo && goldAccountInfo.license,
			userId = license && ((license.subAccount && `${license.account}/${license.subAccount}`) || license.account),
			isActive = goldAccountInfo && goldAccountInfo.active && license && ['mindmup-gold-domain', 'mindmup-gold-team'].includes(license.accountType);
		if (currentContext.isStarted && currentContext.isActive === isActive && currentContext.userId === userId) {
			return Promise.resolve(buildContext());
		}
		currentContext.isActive = !!isActive;
		currentContext.userId = userId;
		currentContext.email = license && license.email;
		currentContext.isStarted = true;
		currentContext.teamList = [];
		if (isActive) {
			return loadTeamList();
		} else {
			return Promise.resolve(sendContext());
		}
	};

	self.reloadTeamList = () => {
		return loadTeamList();
	};
	subscriptionModel.addEventListener('subteam-reload-required', () => {
		return loadTeamList();
	});
	subscriptionModel.addEventListener('subAccountRemoved', () => {
		return loadTeamList();
	});
	self.requestDeleteSubteam = (subteam) => {
		if (subteam) {
			self.dispatchEvent('requestDeleteSubteam', subteam);
		}
	};

	self.requestConfigureSubteam = (subteam) => {
		if (subteam) {
			self.dispatchEvent('requestConfigureSubteam', subteam);
		}

	};

	self.confirmDeleteSubteam = async subteam => {
		if (!subteam || !subteam.teamId) {
			throw new Error('invalid-args');
		}

		await subteamApi.delete(subteam.teamId);
		return loadTeamList();
	};
	self.create = async teamName => {
		if (!teamName) {
			throw new Error('invalid-args');
		}
		await subteamApi.create(teamName);
		return loadTeamList();
	};
	self.changeMemberRole = async (subteam, member, role) => {
		if (!subteam || !subteam.teamId || !member || !member.account || !role) {
			throw new Error('invalid-args');
		}

		const memberList = await subteamApi.changeMemberRole(subteam.teamId, member.account, role);
		if (role === OWNER_ROLE) {
			await loadTeamList();
			self.dispatchEvent('subteamUpdated', refreshSubTeam(subteam));
		}
		return mapMemberList(memberList);
	};
	self.removeMember = (subteam, member) => {
		if (!subteam || !subteam.teamId || !member || !member.account) {
			throw new Error('invalid-args');
		}

		return subteamApi.removeMember(subteam.teamId, member.account)
		.then(memberList => mapMemberList(memberList));
	};
	self.addEmailToTeam = async (subteam, memberEmail, role, addableEmails) => {
		if (!subteam || !subteam.teamId || !memberEmail || !role || !addableEmails) {
			return Promise.reject(new Error('invalid-args'));
		}
		try {
			const inviteResult = await subteamApi.invite(memberEmail, subteam.teamId, role);
			if (role === OWNER_ROLE) {
				await loadTeamList();
			}

			if (typeof inviteResult === 'string') {
				throw inviteResult;
			}
			self.dispatchEvent('showAddableEmails', refreshSubTeam(subteam), addableEmails.filter(email => email !== memberEmail));
		} catch (reason) {
			if (reason === 'account-is-member') {
				self.dispatchEvent('requestConfigureSubteam', subteam);
			} else {
				return Promise.reject(reason);
			}
		};
	};
	self.listAddableMembers = (subteam, memberList) => {
		if (!subteam || !subteam.teamId) {
			throw new Error('invalid-args');
		}
		const memberEmails = memberList && memberList.map(member => member.email);
		return subscriptionModel.getSubscription()
		.then(subscription => {
			if (subscription && subscription.subAccounts) {
				return [subscription.email].concat(subscription.subAccounts.map(subAccount => subAccount.email));
			}
			return subteamApi.listAllowedMembers(subteam.teamId);
		})
		.then(allAddableMembers => {
			const addableEmails = allAddableMembers.filter(addable => !memberEmails || !memberEmails.includes(addable));
			self.dispatchEvent('showAddableEmails', refreshSubTeam(subteam), addableEmails.sort());
		});
	};
	self.loadMemberList = subteam => {
		if (!subteam || !subteam.memberlistUrl) {
			throw new Error('invalid-args');
		}
		return s3Api.loadUrl(subteam.memberlistUrl)
		.then(memberList => mapMemberList(memberList));
	};
	self.invite = (inviteEmail, subteam, role) => {
		if (!subteam || !subteam.teamId || !inviteEmail || !role) {
			throw new Error('invalid-args');
		}
		return subteamApi.invite(inviteEmail, subteam.teamId, role);
	};
};
